import * as React from "react";
import "./buttonPrimary.scss";
import {isNullOrUndefined} from "util";
import Spinner from "../Spinner/Spinner";
import IconWrapper from "../Icon/IconWrapper";
import {IconVariant} from "../Icon/Icon";
import classNames = require("classnames");

interface IProps {
	/**
	 * Button label text.
	 */
	label: string;
	/**
	 * On click event handler.
	 * @param {React.MouseEvent<HTMLButtonElement>} evt
	 */
	onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
	/**
	 * Indicates if button should be disabled.
	 */
	disabled?: boolean;
	/**
	 * Indicates if button have to fit his parent.
	 */
	fit?: boolean;
	/**
	 * Button color variant.
	 */
	variant?: "burgundy" | "danger" | "warning" | "success" | "lighter-blue" | "blue"
	/**
	 * Indicates if loading animation is rendered inside button.
	 */
	isLoading?: boolean;
	/**
	 * Prepend Icon name.
	 */
	prependIcon?: string;
	/**
	 * Icon variant
	 */
	iconVariant?: IconVariant;
	/**
	 * Custom styles
	 */
	customStyles?: React.CSSProperties;
}

export default class ButtonPrimary extends React.Component<IProps, {}> {

	public static defaultProps: Partial<IProps> = {
		variant: "burgundy",
		isLoading: false
	};

	constructor(props: IProps) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	render() {

		const classFromProps = classNames({
			"a-button-primary": true,
			"is-fit": this.props.fit,
			[`${this.props.variant}`]: !isNullOrUndefined(this.props.variant)
		});

		return (
			<button className={classFromProps}
					disabled={this.props.disabled}
					onClick={this.onClick}
					style={this.props.customStyles}>
				{this.props.isLoading ? <Spinner/> : <div>{this.renderPrependIcon()}<span>{this.props.label}</span></div>}
			</button>
		);
	}

	onClick(event: React.MouseEvent<HTMLButtonElement>) {
		if (this.props.onClick && !this.props.disabled) {
			event.stopPropagation();
			this.props.onClick(event);
		}
	}

	/**
	 * Render prepend icon.
	 * @return {JSX.Element}
	 */
	renderPrependIcon = () => {
		if (this.props.prependIcon) {
			return (
				<span className={"icon-prepend"}>
					<IconWrapper
						icon={this.props.prependIcon}
						disabled={this.props.disabled}
						size={14}
						variant={this.props.iconVariant || "gray"}/>
				</span>
			);
		}
		return null;
	};
}
